// Copyright (c) Subzero Labs, Inc.
// SPDX-License-Identifier: Apache-2.0

import type { FrostConfig } from "../config";
import type { AccountEntity } from "../types";

/**
 * Gets all known accounts.
 *
 * @param config - Frost configuration
 * @returns Array of account entities
 */
export function getAccounts(config: FrostConfig): AccountEntity[] {
  return Array.from(config.store.state.accounts.values());
}

/**
 * Gets the currently active (connected) account.
 *
 * @param config - Frost configuration
 * @returns Active account or null if not connected
 */
export function getActiveAccount(config: FrostConfig): AccountEntity | null {
  const { accountAddress, accounts } = config.store.state;
  if (!accountAddress) return null;
  return accounts.get(accountAddress) ?? null;
}

/**
 * Gets a specific account by address.
 *
 * @param config - Frost configuration
 * @param address - Account address to retrieve
 * @returns Account entity or undefined if not found
 */
export function getAccount(config: FrostConfig, address: string): AccountEntity | undefined {
  return config.store.state.accounts.get(address);
}
